import React, { useEffect, useState } from "react";
import { AOSProps } from "../../global/types";

interface ParallaxImageProps extends AOSProps {
  className?: string;
  src: string;
  srcSet?: string;
  alt: string;
}

export const ParallaxImage: React.FC<ParallaxImageProps> = ({
  className,
  src,
  srcSet,
  alt,
  dataAosDelay,
  dataAos
}) => {
  const [offset, setOffset] = useState(0);

  useEffect(() => {
    function handleScroll() {
      setOffset(Math.min(window.pageYOffset * 0.1, 75));
    }

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [offset]);

  return (
    <img
      className={className}
      src={src}
      srcSet={srcSet}
      alt={alt}
      data-aos={dataAos}
      data-aos-delay={dataAosDelay}
      style={{
        transform: `translateY(${offset}px)`
      }}
    />
  );
};
